





































































































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class ObjectIEFix extends Vue {
	data() {
		return {
			title: "Object IE Fit"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
	}
}
